// N.B.: This config should be used in place of ./map.json,
// which is deprecated.
// (Context: https://github.com/VEuPathDB/web-components/issues/324)

import { Viewport } from '../MapVEuMap';

export const defaultAnimationDuration = 300;

export const allColorsHex = [
  '#FFB300',
  '#803E75',
  '#FF6800',
  '#A6BDD7',
  '#C10020',
  '#CEA262',
  '#007D34',
  '#F6768E',
  '#00538A',
  '#FF7A5C',
  '#53377A',
  '#FF8E00',
  '#B32851',
  '#F4C800',
  '#7F180D',
  '#93AA00',
  '#593315',
  '#F13A13',
  '#232C16',
];

export const chartMarkerColorsHex = [
  '#0018A9',
  '#3B1988',
  '#771A66',
  '#B21B45',
  '#ED1C23',
];

// export default viewport for custom zoom control
export const defaultViewport: Viewport = {
  center: [0, 0],
  zoom: 1,
};
